<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.push('/main')" />

                <div>
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('notificationPage.messagesHeader') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div v-if="store?.notifications && currentLocale === 'ua'">
                        <div v-for="month in notificationsKeys" class="notifications-block">
                            <div class="notifications-block__header">{{ month }}</div>
                            <div class="notifications-block__units">
                                <div v-for="notification in store.notifications[month]" class="notification-unit-wrapper">
                                    <div class="notification-unit" :class="{
                                        'error': notification.type === 'danger',
                                        'success': notification.type === 'attention' || !notification?.type
                                    }">
                                        <div class="notification-unit__time">{{ getDateStringByTimestamp(notification.date) }}</div>
                                        <div class="notification-unit__text">{{ notification.message }}</div>
                                        <div class="notification-unit__icon">
                                            <svg v-if="notification.type === 'danger'" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.3006" y="10.521" width="14.4538" height="14.4538" transform="rotate(-45 0.3006 10.521)" stroke="#D81159" stroke-width="0.425112"/>
                                                <rect x="2.12549" y="10.521" width="11.9031" height="11.9031" transform="rotate(-45 2.12549 10.521)" fill="#D81159"/>
                                                <rect x="9.77783" y="5.42017" width="1.70045" height="7.65202" fill="#1B1C22"/>
                                                <rect x="9.77783" y="14.3472" width="1.70045" height="1.70045" fill="#1B1C22"/>
                                            </svg>
                                            <svg v-else width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z" stroke="#E0C522" stroke-width="1.5"/>
                                                <path d="M7 10L10.2929 13.2929C10.6262 13.6262 10.7929 13.7929 11 13.7929C11.2071 13.7929 11.3738 13.6262 11.7071 13.2929L15 10" stroke="#DFC422" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="left-bottom-angle">
                                        <svg v-if="notification.type === 'danger'" width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 0.5V6.5H7" stroke="#D81159" stroke-width="2"/>
                                        </svg>
                                        <svg v-else width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 0.5V6.5H7" stroke="#E0C522" stroke-width="2"/>
                                        </svg>
                                    </div>
                                    <div class="right-top-angle">
                                        <svg v-if="notification.type === 'danger'" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 7L6 1L0 1" stroke="#D81159" stroke-width="2"/>
                                        </svg>
                                        <svg v-else width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 7L6 1L0 1" stroke="#E0C522" stroke-width="2"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="store?.notificationsEng && currentLocale === 'en'">
                        <div v-for="month in notificationsKeysEng" class="notifications-block">
                            <div class="notifications-block__header">{{ month }}</div>
                            <div class="notifications-block__units">
                                <div v-for="notification in store?.notificationsEng[month]" class="notification-unit-wrapper">
                                    <div class="notification-unit" :class="{
                                        'error': notification.type === 'danger',
                                        'success': notification.type === 'attention' || !notification?.type
                                    }">
                                        <div class="notification-unit__time">{{ getDateStringByTimestamp(notification.date) }}</div>
                                        <div class="notification-unit__text">{{ notification.message }}</div>
                                        <div class="notification-unit__icon">
                                            <svg v-if="notification.type === 'danger'" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.3006" y="10.521" width="14.4538" height="14.4538" transform="rotate(-45 0.3006 10.521)" stroke="#D81159" stroke-width="0.425112"/>
                                                <rect x="2.12549" y="10.521" width="11.9031" height="11.9031" transform="rotate(-45 2.12549 10.521)" fill="#D81159"/>
                                                <rect x="9.77783" y="5.42017" width="1.70045" height="7.65202" fill="#1B1C22"/>
                                                <rect x="9.77783" y="14.3472" width="1.70045" height="1.70045" fill="#1B1C22"/>
                                            </svg>
                                            <svg v-else width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z" stroke="#E0C522" stroke-width="1.5"/>
                                                <path d="M7 10L10.2929 13.2929C10.6262 13.6262 10.7929 13.7929 11 13.7929C11.2071 13.7929 11.3738 13.6262 11.7071 13.2929L15 10" stroke="#DFC422" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="left-bottom-angle">
                                        <svg v-if="notification.type === 'danger'" width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 0.5V6.5H7" stroke="#D81159" stroke-width="2"/>
                                        </svg>
                                        <svg v-else width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 0.5V6.5H7" stroke="#E0C522" stroke-width="2"/>
                                        </svg>
                                    </div>
                                    <div class="right-top-angle">
                                        <svg v-if="notification.type === 'danger'" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 7L6 1L0 1" stroke="#D81159" stroke-width="2"/>
                                        </svg>
                                        <svg v-else width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 7L6 1L0 1" stroke="#E0C522" stroke-width="2"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { useMainStore } from '@/store/mainStore';
import { getDateStringByTimestamp } from '@/services/utils';
import ApiManager from '@/services/ApiManager';
import { useI18n } from 'vue-i18n';

function transformNotifications(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};
    if (!data?.notifications) {
        return notificationsByMonth;
    }
    data.notifications.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

function transformNotificationsEng(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};

    if (!data?.notifications_eng) {
        return notificationsByMonth;
    }

    data.notifications_eng.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

export default {
    name: 'NotificationsView',

    setup() {
        const store = useMainStore()
        const notificationsKeys = ref([])
        const notificationsKeysEng = ref([])
        const { t } = useI18n()

        const currentLocale = ref(localStorage.getItem('locale') || 'ua')

        onMounted(async () => {
            const allNotifications = await ApiManager.getAllNotifications(store.user_id)

            const notificationsByMonth = transformNotifications(allNotifications.data, t)

            const notificationsByMonthEng = transformNotificationsEng(allNotifications.data, t)

            store.setCurrentNotificationsEng(notificationsByMonthEng)
            store.setCurrentNotifications(notificationsByMonth)

            if (store.notifications) {
                notificationsKeys.value = Object.keys(store.notifications)
            }

            if (store.notificationsEng) {
                notificationsKeysEng.value = Object.keys(store.notificationsEng)
            }
        })

        return {
            store,
            notificationsKeys,
            currentLocale,
            notificationsKeysEng,
            getDateStringByTimestamp: getDateStringByTimestamp
        }
    }
}
</script>
<style lang="scss">
    .notifications-block {
        margin-top: 30px;
        padding: 0 10px;

        &__header {
            font-size: 10px;
            font-weight: 700;
            color: #FFFFFF;
            margin-bottom: 20px;
            text-align: center;
        }

        .notification-unit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            font-size: 12px;
            color: #FFFFFF;

            &__time {
                font-size: 9px;
                font-weight: 500;
                font-family: 'Montserrat', sans-serif;
            }

            &__text {
                flex: 1;
                margin: 0 10px;
                font-weight: 600;
                font-size: 12px;
                font-family: 'Montserrat', sans-serif;
            }

            &__icon {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            &.success {
                background-color: rgba(#E0C522, 0.05);
                color: #E0C522;
            }

            &.error {
                background-color: rgba(#D81159, 0.05);
                color: #D81159;
            }

        }

        .notification-unit-wrapper {
            padding: 5px;
            margin-bottom: 10px;
            position: relative;

            & > .left-bottom-angle {
                position: absolute;
                bottom: -5px;
                left: 0;
            }

            & > .right-top-angle {
                position: absolute;
                top: -5px;
                right: 0;
            }

        }

    }
</style>
